import React from "react"
import { ExtractedCandidate } from "../../CandidatImport"
import clsx from "clsx"
import MassSaisieSubmissionError from "../MassSaisieSubmissionError"

interface Props {
     candidates: ExtractedCandidate[]
     isSaving: boolean
     duplicateEmails: string[]
     submissionErrors: string[]
     onClearErrors: () => void
     onUpdate: (index: number, field: keyof ExtractedCandidate, val: any) => void
     onRemove: (index: number) => void
     onPreview: (index: number) => void
     onSave: () => void
}

const Step2ExtractionTable = ({ candidates, isSaving, duplicateEmails, submissionErrors, onClearErrors, onUpdate, onRemove, onPreview, onSave }: Props) => {
     return (
          <div className="card shadow-sm border border-gray-200 animate__animated animate__fadeInUp">
               <div className="card-header align-items-start py-5 px-5 border-0 flex-column">
                    <h3 className="fw-bolder text-gray-900 fs-2 m-0">Validation des données</h3>
                    <div className="text-muted fw-semibold fs-7 mb-4">Vérifiez les informations des candidats.</div>

                    {/* Error container moved inside the validation container */}
                    <div className="w-100 mb-5">
                         <MassSaisieSubmissionError errors={submissionErrors} onClear={onClearErrors} />
                    </div>
               </div>
               <div className="card-body p-0">
                    <div className="table-responsive">
                         <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                              <thead>
                                   <tr className="fw-bold text-muted bg-light text-uppercase fs-8">
                                        <th className="w-50px ps-4 text-center">#</th>
                                        <th className="min-w-100px">Civilité</th>
                                        <th className="min-w-150px">Prénom & Nom</th>
                                        <th className="min-w-150px text-primary bg-light-primary bg-opacity-10">Contact</th>
                                        <th className="w-100px text-center">CV</th>
                                        <th className="w-80px text-end pe-4">Actions</th>
                                   </tr>
                              </thead>
                              <tbody>
                                   {candidates.map((c, idx) => {
                                        const isDuplicate = duplicateEmails.includes(c.email)
                                        return (
                                             <tr key={c.id} className={clsx("transition-all", isDuplicate && "bg-light-danger")}>
                                                  <td className="ps-4 text-center fw-bold text-gray-400">{idx + 1}</td>
                                                  <td>
                                                       <select className="form-select form-select-sm" value={c.civility} onChange={e => onUpdate(idx, "civility", e.target.value)}>
                                                            <option value="CIVILITE_MR">M.</option>
                                                            <option value="CIVILITE_MME">Mme</option>
                                                       </select>
                                                  </td>
                                                  <td>
                                                       <div className="d-flex gap-2">
                                                            <input
                                                                 className="form-control form-control-sm"
                                                                 value={c.firstname}
                                                                 onChange={e => onUpdate(idx, "firstname", e.target.value)}
                                                            />
                                                            <input
                                                                 className="form-control form-control-sm"
                                                                 value={c.lastname}
                                                                 onChange={e => onUpdate(idx, "lastname", e.target.value)}
                                                            />
                                                       </div>
                                                  </td>
                                                  <td className={clsx("bg-opacity-5", isDuplicate ? "bg-danger" : "bg-light-primary")}>
                                                       <div className="d-flex flex-column gap-1">
                                                            <input
                                                                 className="form-control form-control-sm border-0 bg-transparent py-0"
                                                                 value={c.phoneNumber}
                                                                 onChange={e => onUpdate(idx, "phoneNumber", e.target.value)}
                                                            />
                                                            <input
                                                                 className={clsx(
                                                                      "form-control form-control-sm border-0 bg-transparent py-0 border-top",
                                                                      isDuplicate ? "border-danger text-danger fw-bold" : "border-gray-200"
                                                                 )}
                                                                 value={c.email}
                                                                 onChange={e => onUpdate(idx, "email", e.target.value)}
                                                            />
                                                       </div>
                                                  </td>
                                                  <td className="text-center">
                                                       <button className="btn btn-icon btn-sm btn-light" onClick={() => onPreview(idx)}>
                                                            <i className="fas fa-file-pdf fs-3 text-danger"></i>
                                                       </button>
                                                  </td>
                                                  <td className="pe-4 text-end">
                                                       <button className="btn btn-icon btn-sm btn-active-light-danger" onClick={() => onRemove(idx)} disabled={isSaving}>
                                                            <i className="fas fa-trash text-gray-400"></i>
                                                       </button>
                                                  </td>
                                             </tr>
                                        )
                                   })}
                              </tbody>
                         </table>
                    </div>
                    <div className="card-footer border-0 d-flex justify-content-end py-8">
                         <button className="btn btn-primary btn-lg px-20 shadow-sm" onClick={onSave} disabled={isSaving}>
                              {isSaving && <span className="spinner-border spinner-border-sm me-2"></span>}
                              Valider et ajouter
                         </button>
                    </div>
               </div>
          </div>
     )
}

export default Step2ExtractionTable
